const PIZZERIA_ORDER_CLIENT_ID_KEY = "panetteria:pizzeria-order-client-id:v1";
const IDEMPOTENCY_WINDOW_MS = 10 * 60 * 1000;

function createRandomId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `client-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreatePizzeriaOrderClientId() {
  if (typeof window === "undefined" || !window.localStorage) {
    return createRandomId();
  }

  const existing = window.localStorage.getItem(PIZZERIA_ORDER_CLIENT_ID_KEY);
  if (existing) {
    return existing;
  }

  const nextId = createRandomId();
  window.localStorage.setItem(PIZZERIA_ORDER_CLIENT_ID_KEY, nextId);
  return nextId;
}

function hashString(value) {
  let hash = 5381;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash * 33) ^ value.charCodeAt(index);
  }

  return (hash >>> 0).toString(36);
}

function buildOrderSignature(selectedEntries) {
  return selectedEntries
    .map((entry) => `${entry.item.id}:${entry.price_index}:${entry.qty}`)
    .sort()
    .join("|");
}

export function buildPizzeriaOrderTrackingPayload(selectedEntries, nowMs = Date.now()) {
  const clientId = getOrCreatePizzeriaOrderClientId();
  const signature = buildOrderSignature(selectedEntries);
  const windowBucket = Math.floor(nowMs / IDEMPOTENCY_WINDOW_MS);
  const signatureHash = hashString(signature);

  return {
    client_id: clientId,
    idempotency_key: `${clientId}:${windowBucket}:${signatureHash}`,
    items: selectedEntries.map((entry) => ({
      menu_item_id: entry.item.id,
      price_index: entry.price_index,
      qty: entry.qty
    }))
  };
}
